










import { Component, Mixins } from "vue-property-decorator";
import { StandardOption } from "../../system/selectors/mixins";
import OptionDropDownSelector from "../../system/selectors/OptionDropDownSelector.vue";
import MstRegistriesEditor from "./dataBase/MstRegistriesEditor.vue";

@Component({
  components: {
    OptionDropDownSelector,
    MstRegistriesEditor,
  }
})
export default class DataBaseEditor extends Mixins() {
  data(): any {
    return {
      contents: [
        new StandardOption<string>("mst.Registries", "mst-registries-editor"),
      ],
      selectedContent: "mst-registries-editor"
    };
  }
  contents: StandardOption<string>[];
  selectedContent: string;

  selectContent(key: string): void {
    this.selectedContent = key;
  }
}
